import { innerSearch } from 'api/Api';
import LoadingIndicator from 'app/components/LoadingIndicator';
import CustomModal from 'app/components/Modal/CustomModal';
import useModals from 'app/components/Modal/manager/useModal';
import { usePaymentState } from 'payment_state/PaymentStateContext';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { useLocation, useNavigate } from 'react-router-dom';

const RedirectPage = () => {
  const { t } = useTranslation();
  const searchParams = useLocation().search;
  // const { paymentState, setPaymentState } = usePaymentState();
  const navigate = useNavigate();
  const [redirectUrl, setRedirectUrl] = useState<string>('');
  const [tid, setTid] = useState<string>('');
  const [schemeCode, setSchemeCode] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const { openModal, closeModal } = useModals();

  useEffect(() => {
    const paramUrl = new URLSearchParams(searchParams).get('payUrl');
    const paramTid = new URLSearchParams(searchParams).get('tid');
    const paramSchemeCode = new URLSearchParams(searchParams).get('schemeCode');

    if (paramUrl && paramTid && paramSchemeCode) {
      setRedirectUrl(paramUrl);
      setTid(paramTid);
      setSchemeCode(paramSchemeCode);
    } else {
      navigate('/error');
      return;
    }
  }, [searchParams, navigate]);

  useEffect(() => {
    if (redirectUrl && schemeCode) {
      if (isMobile) {
        openModal(CustomModal, {
          message: t('open_apm_app', { name: `${schemeCode}` }),
          isShowTwoButton: true,
          isActiveCancel: true,
          onSubmit: () => {
            window.location.replace(`${redirectUrl}`);
          },
          onCancel: () => {
            navigate(`/confirm?tid=${tid}`);
          },
        });
      } else {
        window.location.replace(`${redirectUrl}`);
      }
    }
  }, [redirectUrl, schemeCode]);

  return (
    <>
      <LoadingIndicator />
    </>
  );
};

export default RedirectPage;
